import { render } from "./ReviewRating.vue?vue&type=template&id=3fa53fc8"
import script from "./ReviewRating.vue?vue&type=script&lang=js"
export * from "./ReviewRating.vue?vue&type=script&lang=js"

import "./ReviewRating.vue?vue&type=style&index=0&id=3fa53fc8&lang=scss"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__